import type TableView from '../store/schema/TableView';
import getSelectedTableViewId from './getSelectedTableViewId';
import getListViewStore from '../store/Store';
import type { Module } from 'owa-workloads-module';
import { resolveRowKeysFromTabItemId } from './getEffectiveRowKeys';
import { isGlobalFeatureEnabled } from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import getActiveSecondaryReadingPaneTabItemId from 'owa-tab-store/lib/utils/getActiveSecondaryReadingPaneTabItemId';

export default function getSelectedTableView(
    shouldGetEffectiveTableView?: boolean,
    moduleContext?: Module
): TableView {
    if (
        isGlobalFeatureEnabled('mon-ribbon-secondary-rp-activation') &&
        shouldGetEffectiveTableView
    ) {
        const itemId = getActiveSecondaryReadingPaneTabItemId();
        if (itemId) {
            for (const tableView of getListViewStore().tableViews.values()) {
                const candidateRowKeys = resolveRowKeysFromTabItemId(itemId, tableView);
                if (candidateRowKeys.length > 0) {
                    return tableView;
                }
            }
        }
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (13,5): Type 'TableView | undefined' is not assignable to type 'TableView'.
    // @ts-expect-error
    return getListViewStore().tableViews.get(getSelectedTableViewId(moduleContext));
}

export function getSafeSelectedTableView(moduleContext?: Module): TableView | undefined {
    return getSelectedTableView(undefined /* shouldGetEffectiveTableView */, moduleContext) as
        | TableView
        | undefined;
}
